import type { AuthTokens } from '@pms/shared';

/**
 * Guest-side auth storage for the public BestAcco storefront.
 *
 * IMPORTANT: these storage keys are DELIBERATELY separate from the PMS staff
 * app (which uses `pms_*` keys). A guest account is a different identity from a
 * staff/operator account — they must never share a session or token, even when
 * both apps run on the same machine during development.
 */
const STORAGE_KEYS = {
  ACCESS_TOKEN: 'bestacco_guest_access_token',
  REFRESH_TOKEN: 'bestacco_guest_refresh_token',
  GUEST: 'bestacco_guest',
} as const;

export function getToken(): string | null {
  return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
}

export function setToken(tokens: AuthTokens): void {
  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokens.accessToken);
  localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, tokens.refreshToken);
}

export function clearToken(): void {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.GUEST);
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}
